/**
 * Validación de los filtros de rango de fecha y hora del buscador de turnos.
 * Ambos extremos de cada rango deben completarse juntos (o ninguno).
 */
export const validateDateAndTimeRanges = values => {
	const errors = {}

	const addMonthsPreservingDay = (date, monthsToAdd = 1) => {
		if (!date) return null
		const sourceDate = new Date(date)
		if (Number.isNaN(sourceDate.getTime())) return null

		const sourceDay = sourceDate.getDate()
		const result = new Date(sourceDate)
		result.setDate(1)
		result.setMonth(result.getMonth() + monthsToAdd)

		const lastDayOfTargetMonth = new Date(
			result.getFullYear(),
			result.getMonth() + 1,
			0
		).getDate()

		result.setDate(Math.min(sourceDay, lastDayOfTargetMonth))
		return result
	}

	const toMinutes = date => {
		if (!date) return null
		const parsedDate = new Date(date)
		if (Number.isNaN(parsedDate.getTime())) return null
		return parsedDate.getHours() * 60 + parsedDate.getMinutes()
	}

	if ((values.dateFrom && !values.dateTo) || (!values.dateFrom && values.dateTo)) {
		errors.dateRange = 'Debes seleccionar ambas fechas o ninguna'
	}

	if (values.dateFrom && values.dateTo) {
		const maxAllowedDateTo = addMonthsPreservingDay(values.dateFrom, 2)
		if (maxAllowedDateTo && new Date(values.dateTo) > maxAllowedDateTo) {
			errors.dateRange = 'El rango de fechas no puede superar los dos meses'
		}
	}

	if ((values.hourFrom && !values.hourTo) || (!values.hourFrom && values.hourTo)) {
		errors.timeRange = 'Debes seleccionar ambas horas o ninguna'
	}

	if (values.hourFrom && values.hourTo) {
		const hourFromMinutes = toMinutes(values.hourFrom)
		const hourToMinutes = toMinutes(values.hourTo)

		if (hourFromMinutes != null && hourToMinutes != null && hourFromMinutes > hourToMinutes) {
			errors.timeRange = 'La hora desde debe ser menor o igual a la hora hasta'
		}
	}

	return errors
}
